import * as _ from 'lodash';

export class ReminderLogModalComponent implements ng.IComponentOptions {
  public controller: any = ReminderLogModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
  /*html*/`
  <div class="modal-header">
    <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="datatypeModal">Reminder Logs</h4>
  </div>
  <div class="modal-body">
    <table class="table table-hover table-striped">
      <thead>
        <tr><th>Email</th><th>Datatype</th><th>Sent On</th></tr>
      </thead>
      <tbody>
        <tr ng-repeat="reminder in $ctrl.reminders"><td>{{reminder.target.email}}</td><td>{{reminder.datatype.display_name}}</td><td>{{reminder.sentOn|date:'dd-MM-yyyy'}}</td></tr>
      </tbody>
    </table>
    <ul uib-pagination total-items="$ctrl.total" ng-show="$ctrl.total>0" ng-model="$ctrl.currentPage" ng-change="$ctrl.updatePage()" class="pagination-sm" boundary-links="true" force-ellipses="true" boundary-link-numbers="true"></ul>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
  </div>
  `;
}

export class ReminderLogModalController {
  public static $inject: Array<string> = ["$http", "$timeout"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public reminders: Array<any>;
  public total: number;
  public currentPage: number;
  public resolve: any;
  constructor(private $http: ng.IHttpService, private $timeout: ng.ITimeoutService) {
    this.loadLog(0, 10);
  }
  public loadLog(offset, limit) {
    let datatype;
    this.$timeout(() => {
      if (this.resolve.datatype) {
        datatype = this.resolve.datatype
      }
      else {
        datatype = "";
      }
      this.$http.get(`${BASE}/api/reminder/${datatype}?offset=${offset}&limit=${limit}`)
      .then((d:any) => {
        this.reminders = d.data.results;
        this.total = d.data.total;
      })
    })
  }
  public updatePage() {
    this.loadLog(this.currentPage-1, 10);
  }
  public cancel() {
    this.modalInstance.dismiss('closed');
  }
}
